import { useSyncExternalStore, type ReactElement, type ReactNode } from "react";
import {
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Paper,
  Toolbar,
  Typography,
} from "@mui/material";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ViewListOutlinedIcon from "@mui/icons-material/ViewListOutlined";

const subscribeToPath = (onChange: () => void): (() => void) => {
  window.addEventListener("popstate", onChange);
  return () => window.removeEventListener("popstate", onChange);
};

export const useCurrentPath = (): string =>
  useSyncExternalStore(
    subscribeToPath,
    () => window.location.pathname,
    () => "/",
  );

const navigateTo = (path: string): void => {
  window.history.pushState({}, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
};

export const AppShell = ({
  children,
}: {
  readonly children: ReactNode;
}): ReactElement => {
  const path = useCurrentPath();
  const current = path.startsWith("/swipe")
    ? "/swipe"
    : path.startsWith("/settings")
      ? "/settings"
      : "/";

  return (
    <Box sx={{ minHeight: "100dvh", pb: 9 }}>
      <Toolbar
        sx={{ maxWidth: 1400, width: "100%", mx: "auto", px: { xs: 2, sm: 3 } }}
      >
        <Typography variant="h6" component="div" sx={{ fontWeight: 700 }}>
          Baby Names
        </Typography>
      </Toolbar>
      <Box
        component="main"
        sx={{ maxWidth: 1400, mx: "auto", px: { xs: 2, sm: 3 }, pb: 3 }}
      >
        {children}
      </Box>
      <Paper
        sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 10 }}
        elevation={8}
      >
        <BottomNavigation
          value={current}
          onChange={(_, value: string) => navigateTo(value)}
          showLabels
        >
          <BottomNavigationAction
            label="Manage"
            value="/"
            icon={<ViewListOutlinedIcon />}
          />
          <BottomNavigationAction
            label="Pick"
            value="/swipe"
            icon={<FavoriteBorderIcon />}
          />
          <BottomNavigationAction
            label="Settings"
            value="/settings"
            icon={<SettingsOutlinedIcon />}
          />
        </BottomNavigation>
      </Paper>
    </Box>
  );
};
